fx.translations("it",{
    "Sauvegarde de votre mise en page ..." : "Salvataggio del layout in corso...",

    "Les photos HEIC doivent être totalement téléchargées pour être utilisées pour la création automatique." : "Le immagini HEIC devono essere completamente scaricate per essere utilizzate nella creazione automatica.",

    "Aller à votre album" : "Vai al tuo album",
    "Choisissez votre album en fonction de votre budget" : "Scegli il tuo album in base al tuo budget",
    "Cliquez pour voir les détails" : "Clicca per vedere i dettagli",
    "Pour ajouter une Photo" : "Per aggiungere una foto",
    "Déplacez une photo depuis la galerie" : "Trascina una foto dalla galleria",
    "Sélectionnez au minimum une trentaine de photos" : "Seleziona almeno una trentina di foto"
});

